<script setup>
import {computed, onUnmounted} from 'vue'
import {useRoute} from 'vue-router'
import {useOdpReportsStore} from '@/stores/odpReports'
import {useUserStore} from '@/stores/user'

const props = defineProps({
    allowAll: Boolean
})

const route = useRoute()
const odpReportsStore = useOdpReportsStore()
const userStore = useUserStore()

const formData = computed(() => odpReportsStore.formData)
const franchises = computed(() => odpReportsStore.franchises)
const unsetValue = computed(() => props.allowAll ? 0 : '')
const userFranchiseId = computed(() => userStore.user?.franchiseId ?? 0)
const show = computed(() => userFranchiseId.value === 0)

const initialFranchiseId = route.query.franchiseId
    ? parseInt(route.query.franchiseId)
    : unsetValue.value

formData.value.franchiseId = initialFranchiseId

onUnmounted(() => {
    delete formData.value.franchiseId
})
</script>

<template>
    <select v-if="show" v-model="formData.franchiseId" class="form-select form-select-sm"
            name="franchiseId" required>
        <option v-if="allowAll" :value="0">- All -</option>
        <option v-else value="" selected disabled>Select&hellip;</option>
        <template v-if="franchises">
            <option v-for="franchise in franchises" :key="franchise.id" :value="franchise.id">
                {{ franchise.title }}
            </option>
        </template>
    </select>
</template>